
import React, { useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Card, CardActions, CardContent, Divider, Grid, List, ListItem, ListItemText, TextField, Typography } from '@mui/material';
import { LayoutDashboard } from '../layouts/DasboardLayout';
import { useAuthentication } from '../hooks/useAuthentication';
import { API_URL } from '../config';
import { useFormik } from 'formik';
import toast from 'react-hot-toast';
import MensajeDialog from '../components/Dialogs/MensajeDialog';
import * as Yup from 'yup';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ScrollbarContainer from '../components/ScrollBar/CustomScrollbar';

const initialValues = {
  turno: '',
  peso: '',
  talla: '',
  frecuenciaCardiaca: '',
  frecuenciaRespiratoria: '',
  presionArterialUno: '',
  presionArterialDos: '',
  temperatura: '',
  saturacionCo2: '',
  perimetroAbdominal: '',
  glucosa: '',
};

const validationSchema = Yup.object().shape({
  peso: Yup.string().required('Campo requerido'),
  talla: Yup.string().required('Campo requerido'),
  frecuenciaCardiaca: Yup.string().required('Campo requerido'),
  frecuenciaRespiratoria: Yup.string().required('Campo requerido'),
  presionArterialUno: Yup.string().required('Campo requerido'),
  presionArterialDos: Yup.string().required('Campo requerido'),
  temperatura: Yup.string().required('Campo requerido'),
  saturacionCo2: Yup.string().required('Campo requerido'),
  perimetroAbdominal: Yup.string().required('Campo requerido'),
  glucosa: Yup.string().required('Campo requerido'),
});

const Page = () => {
  const { idUser } = useAuthentication();
  const isXs = window.innerWidth < 600;
  const [formSend, setFormSend] = useState(false);
  const [dataResponse, setDataResponse] = useState(null);
  const [startWithForm, setStartWithForm] = useState(false);
  const [registroEcontrado, setRegistroEncontrado] = useState(false);

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      values.user = idUser;
      const newData = {
        id: dataResponse._id,
        folio: dataResponse.folio,
        estatus: 'Finalizado Signos Vitales',
        data: {
          peso: values.peso,
          talla: values.talla,
          frecuenciaCardiaca: values.frecuenciaCardiaca,
          frecuenciaRespiratoria: values.frecuenciaRespiratoria,
          presionArterialUno: values.presionArterialUno,
          presionArterialDos: values.presionArterialDos,
          temperatura: values.temperatura,
          saturacionCo2: values.saturacionCo2,
          perimetroAbdominal: values.perimetroAbdominal,
          glucosa: values.glucosa,
        },
      };
      try {
        const response = await fetch(`${API_URL}/person/consulta/update`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify(newData),
          }
        );
        if (!response.ok) {
          const errorData = await response.json();
          toast.error(errorData.message);
          return;
        }

        toast.success('Registro guardado correctamente');
        //Recargar la pagina
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } catch (error) {
        console.error(error);
        toast.error('Error al guardar el registro');
      }
    }
  });

  const getByFolio = async (folio) => {
    try {
      const response = await fetch(`${API_URL}/person/consulta/${folio}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );
      const data = await response.json();
      if (!response.ok) {
        const errorData = await response.json();
        toast.error(errorData.message);
        return;
      }
      formik.setValues(data);
      setRegistroEncontrado(true);
      setDataResponse(data);
    } catch (error) {
      console.error(error);
      toast.error('Error al buscar el registro');
    }
  }

  const handleStartWithForm = async () => {
    try {
      const response = await fetch(`${API_URL}/person/consulta/update`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
          },
          body: JSON.stringify({
            id: dataResponse._id,
            estatus: 'En Proceso Signos Vitales',
            folio: dataResponse.folio,
          }),
        }
      );
      //const data = await response.json();
      if (!response.ok) {
        const errorData = await response.json();
        toast.error(errorData.message);
        return;
      }
      toast.success('Registro actualizado correctamente');
      setStartWithForm(true);
    } catch (error) {
      console.error(error);
      toast.error('Error al buscar el registro');
    }
  }

  const [configuracion, setConfiguracion] = useState(null);
  const getConfiguracion = async () => {
    try {
      const response = await fetch(
        `${API_URL}/configuracion/info`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );
      const data = await response.json();
      if (response.ok) {
        setConfiguracion(data);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error('Error fetching configuracion:', error);
      toast.error('Error al obtener la configuración');
    }
  };

  useEffect(() => {
    getConfiguracion();
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        p: 5,
      }}
    >
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={12}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: isXs ? 'column' : 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              height: '100%',
              width: '100%',
            }}
          >
            <Typography
              variant="h4"
              align="center"
              color="textPrimary"
              gutterBottom
              fontWeight={700}
            >
              Signos Vitales
            </Typography>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
              }}
            >
              <TextField
                required
                label="Turno"
                name="turno"
                value={formik.values.turno}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.turno && Boolean(formik.errors.turno)}
                helperText={formik.touched.turno && formik.errors.turno}
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  width: '100%',
                  maxWidth: '300px',
                  backgroundColor: 'white',
                }}
              />
              <Button
                color="primary"
                variant="contained"
                sx={{
                  marginLeft: 2,
                }}
                onClick={() => getByFolio(formik.values.turno)}
              >
                Buscar
              </Button>
            </Box>
          </Box>
        </Grid>

        {dataResponse && (
          <Grid
            item
            xs={12}
            md={dataResponse ? 4 : 12}
          >
            <Accordion
              defaultExpanded
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <Typography
                  component="span"
                  variant="subtitle1"
                  color="primary"
                  fontWeight={700}
                >
                  Datos del paciente
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <List>
                  <ListItem>
                    <ListItemText
                      primary={'Folio'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.folio}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Nombre'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.nombre}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Dirección'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.direccion}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Teléfono'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.telefono}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Fecha de nacimiento'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={new Date(dataResponse?.fechaNacimiento).toLocaleDateString()}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Edad'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.edad}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'CURP'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.curp}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Municipio'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.municipio}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Sexo'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.sexo}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Estatus'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.estatus}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Fecha de creación'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={new Date(dataResponse?.updatedAt).toLocaleDateString()}
                    />
                  </ListItem>
                </List>
              </AccordionDetails>
            </Accordion>
          </Grid>
        )}

        {registroEcontrado && (
          <Grid
            item
            xs={12}
            md={dataResponse ? 8 : 12}
          >
            <Card
              sx={{
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
                flexDirection: 'column',
                borderRadius: '20px',
                padding: 2,
              }}
            >
              <Grid
                container
                spacing={2}
              >
                <Grid
                  item
                  xs={12}
                  md={6}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '100%',
                      height: '100%',
                    }}
                  >
                    <Typography
                      variant="subtitle1"
                      color="textPrimary"
                    >
                      Nombre del paciente:  {" "} <strong>{dataResponse?.nombre ?? ''}</strong>
                    </Typography>
                  </Box>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={6}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: '100%',
                      width: '100%',
                    }}
                  >
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={handleStartWithForm}
                    >
                      Comenzar registro
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Card>
            {startWithForm && (
              <Card
                sx={{
                  display: 'flex',
                  width: '100%',
                  flexDirection: 'column',
                  borderRadius: '20px',
                  marginTop: 5,
                }}
              >
                <CardContent
                  sx={{
                    width: '100%',
                  }}
                >
                  <ScrollbarContainer>
                    <Typography
                      variant="h4"
                      align="center"
                      color="textPrimary"
                      gutterBottom
                      fontWeight={700}
                    >
                      Formulario de Registro {configuracion?.nombre || ''}
                    </Typography>
                    <Typography
                      variant="body1"
                      color="textPrimary"
                      gutterBottom
                    >
                      Formulario de Signos Vitales para asignación de pacientes a especialidades
                    </Typography>
                    <Divider sx={{ mt: 2, mb: 2 }} />
                    <Grid
                      container
                      spacing={2}
                    >
                      <Grid
                        item
                        xs={12}
                        md={6}
                      >
                        <TextField
                          required
                          label="Pesos (kg)"
                          name="peso"
                          type='number'
                          value={formik.values.peso}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.peso && Boolean(formik.errors.peso)}
                          helperText={formik.touched.peso && formik.errors.peso}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          sx={{
                            width: '100%',
                          }}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={6}
                      >
                        <TextField
                          required
                          label="Talla (cm)"
                          name="talla"
                          type='number'
                          value={formik.values.talla}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.talla && Boolean(formik.errors.talla)}
                          helperText={formik.touched.talla && formik.errors.talla}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          sx={{
                            width: '100%',
                          }}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={6}
                      >
                        <TextField
                          required
                          label="Frecuencia Cardiaca"
                          name="frecuenciaCardiaca"
                          type='number'
                          value={formik.values.frecuenciaCardiaca}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.frecuenciaCardiaca && Boolean(formik.errors.frecuenciaCardiaca)}
                          helperText={formik.touched.frecuenciaCardiaca && formik.errors.frecuenciaCardiaca}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          sx={{
                            width: '100%',
                          }}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={6}
                      >
                        <TextField
                          required
                          label="Frecuencia Respiratoria"
                          name="frecuenciaRespiratoria"
                          type='number'
                          value={formik.values.frecuenciaRespiratoria}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.frecuenciaRespiratoria && Boolean(formik.errors.frecuenciaRespiratoria)}
                          helperText={formik.touched.frecuenciaRespiratoria && formik.errors.frecuenciaRespiratoria}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          sx={{
                            width: '100%',
                          }}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={2}
                      >
                        <TextField
                          required
                          label="Presión Arterial"
                          name="presionArterialUno"
                          type='number'
                          value={formik.values.presionArterialUno}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.presionArterialUno && Boolean(formik.errors.presionArterialUno)}
                          helperText={formik.touched.presionArterialUno && formik.errors.presionArterialUno}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          sx={{
                            width: '100%',
                          }}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={1}
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <Typography
                          variant="body1"
                          color="textPrimary"
                          textAlign={'center'}
                        >
                          /
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={2}
                      >
                        <TextField
                          required
                          label="Presión Arterial"
                          name="presionArterialDos"
                          type='number'
                          value={formik.values.presionArterialDos}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.presionArterialDos && Boolean(formik.errors.presionArterialDos)}
                          helperText={formik.touched.presionArterialDos && formik.errors.presionArterialDos}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          sx={{
                            width: '100%',
                          }}
                        />
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        md={1}
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <Typography
                          variant="body1"
                          color="textPrimary"
                          gutterBottom
                        >
                          mmHg
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={6}
                      >
                        <TextField
                          required
                          label="Temperatura"
                          name="temperatura"
                          type='number'
                          value={formik.values.temperatura}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.temperatura && Boolean(formik.errors.temperatura)}
                          helperText={formik.touched.temperatura && formik.errors.temperatura}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          sx={{
                            width: '100%',
                          }}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={6}
                      >
                        <TextField
                          required
                          label="Saturación de Oxígeno"
                          name="saturacionCo2"
                          type='number'
                          value={formik.values.saturacionCo2}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.saturacionCo2 && Boolean(formik.errors.saturacionCo2)}
                          helperText={formik.touched.saturacionCo2 && formik.errors.saturacionCo2}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          sx={{
                            width: '100%',
                          }}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={6}
                      >
                        <TextField
                          required
                          label="Perímetro Abdominal"
                          name="perimetroAbdominal"
                          type='number'
                          value={formik.values.perimetroAbdominal}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.perimetroAbdominal && Boolean(formik.errors.perimetroAbdominal)}
                          helperText={formik.touched.perimetroAbdominal && formik.errors.perimetroAbdominal}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          sx={{
                            width: '100%',
                          }}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={6}
                      >
                        <TextField
                          required
                          label="Glucosa"
                          name="glucosa"
                          type='number'
                          value={formik.values.glucosa}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.glucosa && Boolean(formik.errors.glucosa)}
                          helperText={formik.touched.glucosa && formik.errors.glucosa}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          sx={{
                            width: '100%',
                          }}
                        />
                      </Grid>
                    </Grid>
                  </ScrollbarContainer>
                </CardContent>
                <CardActions
                  sx={{
                    display: 'flex',
                    justifyContent: 'right',
                    width: '100%',
                    padding: 2,
                  }}
                >
                  <Button
                    color="error"
                    variant="outlined"
                    onClick={formik.resetForm}
                  >
                    Limpiar
                  </Button>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={formik.handleSubmit}
                  >
                    Guardar
                  </Button>
                </CardActions>
              </Card>
            )}
          </Grid>
        )}
      </Grid>
      <MensajeDialog
        open={formSend}
        data={dataResponse}
        handleClose={() => setFormSend(false)}
      />
    </Box>
  );
};

const SignosVitales = () => {
  return (
    <LayoutDashboard>
      <Page />
    </LayoutDashboard>
  );
}

export default SignosVitales;
